import React from 'react';

// interface ErrorMessage {
//     msg: string;
// }

export interface FlashMessageData {
    errors?: {msg: string}[];
    success_msg?: string;
    error_msg?: string;
    error?: string;
    hideClose?: boolean;
}

interface FlashMessagesProps {
    props?: FlashMessageData;
}

interface CloseButtonProps {
    props?: {
        hideClose?: boolean;
    };
}

export default function FlashMessages({ props }: FlashMessagesProps) {
    if (!props) return null;
    return (
        <>
        {
            props.errors &&
            <>
            {
                props.errors.map((error, index) => 
                    <div key={index} className="alert alert-warning alert-dismissible fade show" role="alert">
                        <div dangerouslySetInnerHTML={{__html: error.msg}}/>
                        <CloseButton props={props}/>
                    </div>
                )
            }
            </>
        }
        {
            props.success_msg && props.success_msg.length > 0 &&
            <div className="alert alert-success alert-dismissible fade show" role="alert">
                <div dangerouslySetInnerHTML={{__html: props.success_msg}}/>
                <CloseButton props={props}/>
            </div>
        }
        {
            props.error_msg && props.error_msg.length > 0 &&
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <div dangerouslySetInnerHTML={{__html: props.error_msg}}/>
                <CloseButton props={props}/>
            </div>
        }
        {
            props.error && props.error.length > 0 &&
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <div dangerouslySetInnerHTML={{__html: props.error}}/>
                <CloseButton props={props}/>
            </div>
        }
        </>
    );
}

function CloseButton({ props }: CloseButtonProps) {
    if (!props) return null;
    if (props.hideClose) return null;

    return (
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    );
}